import { Controller } from 'react-hook-form';
import { FormHelperText, Typography, Checkbox, FormControlLabel, Grid } from '@mui/material';

const CheckBoxField = ({ controller, label, required = false, setValue, ...props }) => {
  const onFormChange = (checked, label, value) => {
    if (!value) {
      value = [];
    }
    if (checked) {
      value.push(label);
      setValue(controller.name, [...value]);
    } else {
      let index = value.indexOf(label);
      value.splice(index, 1);
      setValue(controller.name, [...value]);
    }
  };
  return (
    <div>
      {label && (
        <>
          <Typography variant="caption">{label}</Typography>
          <br />
        </>
      )}

      {controller ? (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Controller
            control={controller.control}
            name={controller.name}
            rules={{ required }}
            render={({ field: { onChange, value, onBlur } }) => {
              return controller.options.map((label, index) => (
                <Grid key={index} item xs={6}>
                  <FormControlLabel
                    onChange={(e) => {
                      onFormChange(e.target.checked, label, value);
                    }}
                    onBlur={onBlur}
                    control={<Checkbox size="small" />}
                    label={label}
                    value={value}
                  />
                </Grid>
              ));
            }}
          />
          {controller.errors && (
            <FormHelperText xs={12} sx={{ width: '100%', color: 'error.main' }}>
              {controller.errors.message}
            </FormHelperText>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default CheckBoxField;
